import * as _ from 'lodash';

import { ConnectionPointType as CPType } from '../../../../models/';
import * as constants from '../../../../common/constants';

export interface IConnectionPointConfiguration {
    type: CPType;
    friendlyName: string;
    hasAddress?: boolean;
    hasAddressMandatory?: boolean;
    hasAllowOverwrite?: boolean;
    hasArchive?: boolean;
    hasArchiveMandatory?: boolean;
    hasAutoLoad?: boolean;
    hasConnectionPointType?: boolean;
    hasCreateDatabase?: boolean;
    hasCredentialsMandatory?: boolean;
    hasDatabase?: boolean;
    hasDatabaseMandatory?: boolean;
    hasDefaultSender?: boolean;
    hasExport?: boolean;
    hasExportLogbook?: boolean;
    hasFrequency?: boolean;
    hasIgnoreSSLErrors?: boolean;
    hasImport?: boolean;
    hasMandatoryDefaultSender?: boolean;
    hasName?: boolean;
    hasPassword?: boolean;
    hasQuerySet?: boolean;
    hasRaw?: boolean;
    hasSchema?: boolean;
    hasScriptFile?: boolean;
    hasTagsFile?: boolean;
    hasTimeZone?: boolean;
    hasUseSSL?: boolean;
    hasUserFields?: boolean;
    hasUsername?: boolean;
}

export const connectionPointConfigurationDictionnary: { [type: number]: IConnectionPointConfiguration } = {};

const connectionPointTypes = constants.connectionPointTypes;
const cpType: { [type: number]: string } = {};
_.forEach(connectionPointTypes, (t) => (cpType[t.key] = t.value));
const list: IConnectionPointConfiguration[] = [
    {
        type: CPType.PI,
        friendlyName: cpType[CPType.PI],
        hasAddress: true,
        hasUsername: true,
        hasPassword: true,
        hasTagsFile: true,
        hasAllowOverwrite: true,
        hasExport: true,
        hasImport: true,
        hasRaw: true,
        hasAddressMandatory: true
    },
    {
        type: CPType.SQL,
        friendlyName: cpType[CPType.SQL],
        hasAddress: true,
        hasDatabase: true,
        hasUsername: true,
        hasPassword: true,
        hasCredentialsMandatory: true,
        hasDatabaseMandatory: true,
        hasAddressMandatory: true,
        hasQuerySet: true
    },
    {
        type: CPType.WideDatabase,
        friendlyName: cpType[CPType.WideDatabase],
        hasAddress: true,
        hasDatabase: true,
        hasUsername: true,
        hasPassword: true,
        hasFrequency: true,
        hasCreateDatabase: true,
        hasCredentialsMandatory: false,
        hasDatabaseMandatory: true,
        hasAddressMandatory: true
    },
    {
        type: CPType.Excel,
        friendlyName: cpType[CPType.Excel],
        hasAddress: true,
        hasAddressMandatory: true
    },
    {
        type: CPType.csv,
        friendlyName: cpType[CPType.csv],
        hasAddress: true,
        hasTagsFile: true,
        hasAddressMandatory: true
    },
    {
        type: CPType.Manual,
        friendlyName: cpType[CPType.Manual],
        hasTagsFile: true
    },
    {
        type: CPType.OPCHDA,
        friendlyName: cpType[CPType.OPCHDA],
        hasAddress: true,
        hasDatabase: true,
        hasTagsFile: true,
        //hasDatabaseMandatory: true,
        hasImport: true,
        hasRaw: true,
        hasAddressMandatory: true
    },
    {
        type: CPType.SMTP,
        friendlyName: cpType[CPType.SMTP],
        hasAddress: true,
        hasUsername: true,
        hasPassword: true,
        hasUseSSL: true,
        hasDefaultSender: true,
        hasAddressMandatory: true,
        hasMandatoryDefaultSender: true
    },
    {
        type: CPType.CSVDataTable,
        friendlyName: cpType[CPType.CSVDataTable],
        hasAddress: true,
        hasTagsFile: true,
        hasImport: true,
        hasAddressMandatory: true
    },
    {
        type: CPType.Wonderware,
        friendlyName: cpType[CPType.Wonderware],
        hasAddress: true,
        hasUsername: true,
        hasPassword: true,
        hasTagsFile: true,
        hasCredentialsMandatory: false,
        hasImport: true,
        hasRaw: true,
        hasAddressMandatory: true
    },
    {
        type: CPType.DataGeneration,
        friendlyName: cpType[CPType.DataGeneration],
        hasAddress: true,
        hasTagsFile: true,
        hasFrequency: true,
        hasImport: true
    },
    {
        type: CPType.ManualFile,
        friendlyName: cpType[CPType.ManualFile],
        hasTagsFile: true,
        hasArchive: true
    },
    {
        type: CPType.PIAF,
        friendlyName: cpType[CPType.PIAF],
        hasAddress: true,
        hasDatabase: true,
        hasUsername: true,
        hasPassword: true,
        hasTagsFile: true,
        hasImport: true,
        hasRaw: true,
        hasAddressMandatory: true
    },
    {
        type: CPType.PepiteDataLake,
        friendlyName: cpType[CPType.PepiteDataLake],
        hasAddress: true,
        hasUsername: true,
        hasPassword: true,
        //hasCredentialsMandatory: true,
        hasImport: true,
        hasRaw: true,
        hasAddressMandatory: true
    },
    {
        type: CPType.DataFolder,
        friendlyName: cpType[CPType.DataFolder],
        hasAddress: true,
        hasArchive: true,
        hasAddressMandatory: true,
        hasAutoLoad: true,
        hasScriptFile: true
    },
    {
        type: CPType.HTTP,
        friendlyName: cpType[CPType.HTTP],
        hasAddress: true,
        hasUsername: true,
        hasPassword: true,
        hasExportLogbook: true,
        hasIgnoreSSLErrors: true,
        hasAllowOverwrite: true,
        hasExport: true,
        hasAddressMandatory: true,
        hasTimeZone: true,
        hasArchive: true
    },
    {
        type: CPType.Oracle,
        friendlyName: cpType[CPType.Oracle],
        hasAddress: true,
        hasUsername: true,
        hasPassword: true,
        hasDatabase: true,
        hasDatabaseMandatory: true,
        hasCredentialsMandatory: true,
        hasAddressMandatory: true,
        hasQuerySet: true
    },
    {
        type: CPType.GridVis,
        friendlyName: cpType[CPType.GridVis],
        hasAddress: true,
        hasUsername: true,
        hasPassword: true,
        hasDatabase: true,
        hasDatabaseMandatory: true,
        hasCredentialsMandatory: true,
        hasAddressMandatory: true,
        hasQuerySet: false,
        hasIgnoreSSLErrors: true
    },
    {
        type: CPType.FaSTRepo,
        friendlyName: cpType[CPType.FaSTRepo],
        hasAddress: true,
        hasUsername: false,
        hasPassword: false,
        hasDatabase: false,
        hasFrequency: true,
        hasTagsFile: true,
        hasAddressMandatory: true
    },
    {
        type: CPType.CSVExport,
        friendlyName: cpType[CPType.CSVExport],
        hasAddress: true,
        hasUsername: false,
        hasPassword: false,
        hasDatabase: false,
        hasFrequency: false,
        hasTagsFile: false,
        hasAddressMandatory: true,
        hasTimeZone: true
    },
    {
        type: CPType.MariaDB,
        friendlyName: cpType[CPType.MariaDB],
        hasAddress: true,
        hasDatabase: true,
        hasDatabaseMandatory: true,
        hasPassword: true,
        hasTagsFile: true,
        hasUsername: true,
        hasUseSSL: true,
        hasCredentialsMandatory: true,
        hasAddressMandatory: true,
        hasQuerySet: true
    },
    {
        type: CPType.ArchestrA,
        friendlyName: cpType[CPType.ArchestrA],
        hasAddress: true,
        hasUsername: true,
        hasPassword: true,
        hasTagsFile: true,
        hasCredentialsMandatory: false,
        hasImport: true,
        hasRaw: true,
        hasAddressMandatory: true,
        hasQuerySet: true
    },
    {
        type: CPType.DataMailBox,
        friendlyName: cpType[CPType.DataMailBox],
        hasAddress: true,
        hasDatabase: true,
        hasUsername: true,
        hasPassword: true,
        hasTagsFile: true,
        hasDatabaseMandatory: true,
        hasCredentialsMandatory: true,
        hasImport: true,
        hasRaw: true,
        hasAddressMandatory: true,
        hasQuerySet: false
    },
    {
        type: CPType.Npgsql,
        friendlyName: cpType[CPType.Npgsql],
        hasAddress: true,
        hasDatabase: true,
        hasUsername: true,
        hasPassword: true,
        hasCredentialsMandatory: true,
        hasDatabaseMandatory: true,
        hasAddressMandatory: true,
        hasQuerySet: true,
        hasSchema: true
    },
    {
        type: CPType.WideDatabaseNpgsql,
        friendlyName: cpType[CPType.WideDatabaseNpgsql],
        hasAddress: true,
        hasDatabase: true,
        hasUsername: true,
        hasPassword: true,
        hasFrequency: true,
        hasCreateDatabase: true,
        hasCredentialsMandatory: false,
        hasDatabaseMandatory: true,
        hasAddressMandatory: true,
        hasSchema: false
    },
    {
        type: CPType.FaSTInfluxDB2,
        friendlyName: cpType[CPType.FaSTInfluxDB2],
        hasAddress: true,
        hasDatabase: true,
        hasUsername: true,
        hasPassword: true,
        hasFrequency: false,
        hasCredentialsMandatory: true,
        hasDatabaseMandatory: true,
        hasAddressMandatory: true
    },
    {
        type: CPType.Bazefield,
        friendlyName: cpType[CPType.Bazefield],
        hasAddress: true,
        hasPassword: true,
        hasTagsFile: true,
        hasAddressMandatory: true,
        hasCredentialsMandatory: true
    },
    {
        type: CPType.Argus,
        friendlyName: cpType[CPType.Argus],
        hasAddress: true,
        hasAddressMandatory: true,
        hasCredentialsMandatory: false,
        hasPassword: true,
        hasTagsFile: true,
        hasUsername: true,
        hasRaw: true
    },
    {
        type: CPType.Ewattch,
        friendlyName: cpType[CPType.Ewattch],
        hasAddress: true,
        hasAddressMandatory: true,
        hasCredentialsMandatory: true,
        hasPassword: true,
        hasTagsFile: true,
        hasUsername: true,
        hasRaw: true,
        hasImport: true
    },
    {
        type: CPType.HydrometrieKiwis,
        friendlyName: 'Walloon hydrometry API',
        hasAddress: false,
        hasAddressMandatory: false,
        hasCredentialsMandatory: false,
        hasPassword: true,
        hasTagsFile: true,
        hasUsername: false,
        hasRaw: true,
        hasImport: true
    }
];

_.forEach(list, (c) => {
    c.hasName = true;
    c.hasUserFields = true;
    c.hasConnectionPointType = true;
    connectionPointConfigurationDictionnary[c.type] = c;
});
